import { connect } from 'react-redux';
import Scheduler from '../../../components/DailyPlanning/Scheduler/Scheduler';
import {
  dismissErrors,
  changeSchedulerMapView,
  setAutoAllocationLogSetting,
  toggleSchedulerModeView,
  getDailyPlanningDetails,
} from '../../../actions/areas/dailyPlanning';
import { getPostings, getLocationsForPostings, getSettings, resetPostings } from '../../../actions/entities';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { selectSelectedDate, selectSelectedTeam } from '../../../reducers/areas/dailyPlanning';
import { getSelectorOptions } from '../../../actions/uiElements/selectors';
import { bandsEndpoint, autoAllocationStatuses } from '../../../settings/constants';

import {
  selectDenormalizedPostings,
  selectPostingLocationsWithBands,
} from '../../../reducers/entities/postings/selectors';

const mapStateToProps = state => {
  const {
    areas: { dailyPlanning },
    entities: { postings, settings },
    global: { auth },
    areas: {
      dailyPlanning: { autoAllocate },
    },
  } = state;
  const { dayStart, dayEnd } = postings.general;

  const denormalizedPostings = selectDenormalizedPostings(state);
  return {
    isAutoAllocating: autoAllocate.status !== autoAllocationStatuses.IDLE,
    isUnAllocating: autoAllocate.isUnAllocating,
    autoAllocateDate: autoAllocate.date,
    autoAllocateTeamId: autoAllocate.teamId,
    isAutoAllocateInProgress:
      autoAllocate.status !== autoAllocationStatuses.IDLE || autoAllocate.isAllocating || autoAllocate.isUnAllocating,
    selectedDate: selectSelectedDate(state),
    selectedTeam: selectSelectedTeam(state),
    postings: denormalizedPostings instanceof Array ? denormalizedPostings : [],
    locationsForPostings: selectPostingLocationsWithBands(state),
    settings: settings.systemSettings,
    dayStart,
    dayEnd,
    serverDateTime: postings.general.serverDateTime || postings.locations.serverDateTime,
    isFetching: postings.general.isFetching || postings.locations.isFetching,
    canAllocateWork: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAllocateWork),
    failureMessage: dailyPlanning.userMessages.failure,
    successMessage: dailyPlanning.userMessages.success,
    selectedClinicianId: dailyPlanning.schedulerMapView.selectedClinicianId,
    mapViewState: dailyPlanning.schedulerMapView.mapViewState,
    downloadingPlan: dailyPlanning.clinicianPlan.downloading,
    appSettings: settings.appSettings,
    isNightMode: dailyPlanning.scheduler.isNightMode,
  };
};

const mapDispatchToProps = dispatch => ({
  dismissErrors: () => {
    dispatch(dismissErrors());
  },
  getAppSettings: kv => dispatch(getSettings(kv)),
  changeSchedulerMapView: isMapView => dispatch(changeSchedulerMapView(isMapView)),
  setAutoAllocationLogSetting: log => dispatch(setAutoAllocationLogSetting(log)),
  fetchPostings: (forceUpdate, silent, isNightMode, selectedDate, schedulerModeStartTime, schedulerModeEndTime) => {
    dispatch(getSelectorOptions(bandsEndpoint, 'bands'));
    dispatch(getPostings(forceUpdate, silent, isNightMode, selectedDate, schedulerModeStartTime, schedulerModeEndTime));
  },
  fetchLocationsForPostings: forceUpdate => {
    dispatch(getSelectorOptions(bandsEndpoint, 'bands'));
    dispatch(getLocationsForPostings(forceUpdate));
  },
  toggleSchedulerModeView: () => {
    dispatch(dismissErrors());
    dispatch(toggleSchedulerModeView());
    dispatch(resetPostings());
    dispatch(getDailyPlanningDetails());
  },
});

const SchedulerWithClinicians = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Scheduler);

export default SchedulerWithClinicians;
